import { render, staticRenderFns } from "./ContentSummary.vue?vue&type=template&id=06ba3e28&scoped=true&"
import script from "./ContentSummary.vue?vue&type=script&lang=js&"
export * from "./ContentSummary.vue?vue&type=script&lang=js&"
import style0 from "./ContentSummary.vue?vue&type=style&index=0&id=06ba3e28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ba3e28",
  null
  
)

/* custom blocks */
import block0 from "./ContentSummary.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports